import React from 'react';
import Link from 'next/link';
import styled from 'styled-components';
import type { LinkProps } from 'next/link';
import { royalBlue } from '../../../utils/customColors';

const StyledLink = styled.a`
    color: ${royalBlue};
    text-decoration: underline;
    font-weight: 600;
`;

type AnswerLinkProps = LinkProps & {
    href: string;
    children?: React.ReactNode;
    onClick?: () => void;
};

export function AnswerLink({ onClick, href, children }: AnswerLinkProps) {
    return (
        <Link href={href} passHref shallow>
            <StyledLink href={href} onClick={onClick}>
                {children}
            </StyledLink>
        </Link>
    );
}
